<template><div><h2 id="default-width" tabindex="-1" class="d-docsite--header-2">Default Width <a class="header-anchor d-link d-docsite--link d-link" href="#default-width" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-divide-{y|x}</code> to create a 1px divider between an element's child items.</p>
<code-example source-code='&lt;dt-stack class=&quot;d-divide-y d-divide-default d-w100p&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;
&lt;dt-stack direction=&quot;row&quot; class=&quot;d-divide-x d-divide-default d-w100p&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;'>
<dt-stack class="d-divide-y d-divide-default d-w100p">
  <dt-stack direction="row" align="center" justify="center" class="d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200">3</dt-stack>
</dt-stack>
<dt-stack direction="row" class="d-divide-x d-divide-default d-w100p">
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">3</dt-stack>
</dt-stack>
</code-example>
<h2 id="changing-the-divider-width" tabindex="-1" class="d-docsite--header-2">Changing the Divider Width <a class="header-anchor d-link d-docsite--link d-link" href="#changing-the-divider-width" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-divide-{y|x}{n}</code> to change the divider width between an element's child items.</p>
<code-example source-code='&lt;code&gt;d-divide-x0&lt;/code&gt;
&lt;dt-stack direction=&quot;row&quot; class=&quot;d-divide-x d-divide-x0 d-divide-default d-w100p d-ba d-bc-default&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;
&lt;code&gt;d-divide-x2&lt;/code&gt;
&lt;dt-stack direction=&quot;row&quot; class=&quot;d-divide-x d-divide-x2 d-divide-default d-w100p d-ba d-bc-default d-baw2&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;
&lt;code&gt;d-divide-x4&lt;/code&gt;
&lt;dt-stack direction=&quot;row&quot; class=&quot;d-divide-x d-divide-x4 d-divide-default d-w100p d-ba d-bc-default d-baw4&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;'>
<code>d-divide-x0</code>
<dt-stack direction="row" class="d-divide-x d-divide-x0 d-divide-default d-w100p d-ba d-bc-default">
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">3</dt-stack>
</dt-stack>
<code>d-divide-x2</code>
<dt-stack direction="row" class="d-divide-x d-divide-x2 d-divide-default d-w100p d-ba d-bc-default d-baw2">
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">3</dt-stack>
</dt-stack>
<code>d-divide-x4</code>
<dt-stack direction="row" class="d-divide-x d-divide-x4 d-divide-default d-w100p d-ba d-bc-default d-baw4">
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">3</dt-stack>
</dt-stack>
</code-example>
<h2 id="reversing-the-divider-direction" tabindex="-1" class="d-docsite--header-2">Reversing the Divider Direction <a class="header-anchor d-link d-docsite--link d-link" href="#reversing-the-divider-direction" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">If an element's <code v-pre>flex-direction</code> is reversed, apply <code v-pre>d-divide-{y|x}-reverse</code> to reverse the divider placement between an element's child items.</p>
<code-example source-code='&lt;dt-stack direction=&quot;row-reverse&quot; class=&quot;d-divide-x d-divide-default d-divide-x-reverse d-w100p&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-w100p d-p-200&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;'>
<dt-stack direction="row-reverse" class="d-divide-x d-divide-default d-divide-x-reverse d-w100p">
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-w100p d-p-200">3</dt-stack>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody v-for="d in ['y', 'x']">
      <tr v-for="i in ['default', '0', '2', '4']">
        <th scope="row" class="d-code--sm d-docsite-code">
          d-divide-{{ d }}<span v-if="i !== 'default'" v-text="i"></span> > *+*
        </th>
        <td class="d-code--sm">
          --divide-{{ d }}-reverse: 0;<br/>
          <span v-if="d === 'y'">
            border-block-start: calc(
              <span v-if="i === 'default'">1</span>
              <span v-else>{{ i }}</span>
              px *(1 - var(--divide-{{ d }}-reverse))
            ) solid !important;<br/>
            border-block-end: calc(
              <span v-if="i === 'default'">1</span>
              <span v-else>{{ i }}</span>
* var(--divide-{{ d }}-reverse)
            ) solid !important;
          </span>
          <span v-else>
            border-inline-end: calc(
              <span v-if="i === 'default'">1</span>
              <span v-else>{{ i }}</span>
              px*var(--divide-{{ d }}-reverse)
            ) solid !important;<br/>
            border-inline-start: calc(
              <span v-if="i === 'default'">1</span>
              <span v-else>{{ i }}</span>
*(1 - var(--divide-{{ d }}-reverse))
            ) solid !important;
          </span>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


